import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=2ac24d3c"
import script from "./FeedbackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports